export function getdata() {
	let obj = {
		headData: [{
			title: '选择',
			prop: 'id',
			width: '60',
			custom: true,
		}, {
			title: '父级编码',
			prop: 'shangjjdbm',
			issort: true,
			width: '160'
		}, {
			title: '税收分类编码',
			prop: 'shuisbm',
			issort: true,
			width: '160'
		}, {
			title: '名称',
			prop: 'shangpmc',
			issort: true,
			width: '100'
		}, {
			title: '简称',
			prop: 'shangpbmjc',
			issort: true,
			width: '100'
		}, {
			title: '税率',
			prop: 'zzssl',
			issort: true,
			// showFilter: true,
			// checkList: [],
			// dataList: [{
			// 		name: "13%",
			// 		code: "0.13"
			// 	},
			// 	{
			// 		name: "测试字段二",
			// 		code: "2"
			// 	},
			// 	{
			// 		name: "测试字段三",
			// 		code: "3"
			// 	}
			// ]
		}, {
			title: '关键字',
			prop: 'guanjz',
			issort: true,
			width: '120'
		}, {
			title: '说明',
			prop: 'shuom',
			issort: true,
			width: '180'
		}, {
			title: '有效期',
			prop: 'youxq',
			issort: true,
			width: '100'
		}, ],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},


	}
	return obj
}